import ReactGA from 'react-ga';
import { useLocation } from 'react-router-dom';

const useGaTracker = () => {
  const location = useLocation();
    ReactGA.pageview(location.pathname + location.search);
};

export default useGaTracker;
